module.exports = __webpack_public_path__ + "static/img/logo.8952a489.svg";